"use client";

import { RWA_ICON } from "~/consts";
import { Routes } from "~/routes";
import { Link } from "~/components/Link";

// // // //

/**
 * NotFound
 * Our 404 page
 */
export function NotFound() {
    return (
        <div className="min-h-full pt-16 pb-12 flex flex-col select-none">
            <main className="grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col gap-4 items-center select-none">
                    <img src={RWA_ICON} className="h-18" />
                </div>

                <div className="pb-16 pt-6">
                    <div className="text-center">
                        <h1 className="text-4xl text-foreground tracking-tight sm:text-5xl">
                            Page not found.
                        </h1>
                        <p className="mt-6 text-xl text-foreground">
                            {
                                "Sorry, we couldn't find the page you're looking for."
                            }
                        </p>
                        <div className="mt-6">
                            <Link
                                href={Routes.home}
                                variant="default"
                                className="text-base"
                                analyticsLabel="404 Page - Go Back Home"
                            >
                                <span aria-hidden="true">&larr; &nbsp;</span>
                                Go back home
                            </Link>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
